export const EARTH_RADIUS = 6.371e6;
